import Typography from "@mui/material/Typography";
import React from "react";
import AppBar from "@mui/material/AppBar";
import ToolbarMui from "@mui/material/Toolbar";
import ListItemText from "@mui/material/ListItemText";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import Grid from "@mui/material/Grid";
import AvatarIcon from "../assets/icons/avatar.svg";
import WalletIcon from "../assets/icons/wallet_icon.svg";
import AddCardIcon from "@mui/icons-material/AddCard";
import EditLocationAltIcon from '@mui/icons-material/EditLocationAlt';
import WysiwygIcon from '@mui/icons-material/Wysiwyg';
import {AVATAR_BASE_URL_API, BASE_URL_API} from "../Const";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import MuiAlert from "@mui/material/Alert";
import {Snackbar} from "@mui/material";
import {BackButton, BottomMenu} from './HookUtils'
import IconButton from "@mui/material/IconButton";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

export class ProfileComponent extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            userData: null,
            name: null,
            address: null,
            postalcode: null,
            openSnackbar: false,
            message: ""
        }
    }

    getUserData() {
        fetch(BASE_URL_API + 'user', {
            headers: {
                'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                'Content-Type': 'application/json'
            }
        })
            .then(response => response.json())
            .then(results => {
                    if (results.code === "200") {

                        this.setState({
                            userData: results.data,
                            name: results.data.name,
                            address: results.data.address,
                            postalcode: results.data.postalcode
                        })
                    }


                },
                (error) => {
                    console.log("error")

                }
            );
    }

    componentDidMount() {

        this.getUserData()
    }


    render() {
        const handleOnchangeName = (e) => {
            this.setState({name: e.target.value})
        }
        const handleOnchangeAddress = (e) => {
            this.setState({address: e.target.value})
        }

        const handleOnchangePostalcode = (e) => {
            this.setState({postalcode: e.target.value})
        }


        const handleCloseSnackbar = (e) => {
            this.setState({openSnackbar: false})
        }

        const onUpdateProfileClicked = () => {
            fetch(BASE_URL_API + 'user', {
                method: 'PUT',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem("pwa_token"),
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    name: this.state.name,
                    address: this.state.address,
                    postalcode: this.state.postalcode
                })
            })
                .then(response => response.json())
                .then(result => {
                    if (result.code === "200") {
                        this.getUserData()

                        this.setState({
                            userData: result.data,
                            openSnackbar: true,
                            message: "حساب کاربری با موفقیت ویرایش شد."
                        })

                    } else {
                        this.setState({openSnackbar: true, message: result.message, snackbarType: "error"})
                    }


                })
        };

        return (
            <React.Fragment>
                <AppBar style={{background: 'rgba(238,238,238,0.3)', overflow: 'auto', display: 'flex'}}>
                    <ToolbarMui>

                        <IconButton style={{color: 'black'}} size="large"> <AccountCircleIcon/></IconButton>

                        <ListItemText align="center"><strong style={{
                            fontSize: 18,
                            overflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            color: 'black'
                        }}>پروفایل</strong></ListItemText>

                        <BackButton/>
                    </ToolbarMui>

                </AppBar>
                <div style={{width: '100%'}} alignItems='center' justifyContent='center' align='center'>
                    <Grid container alignItems='center' justifyContent='center' align='center'
                          style={{marginTop: 72, width: '100%'}}>
                        {
                            (this.state.userData === null) ?
                                (
                                    <Grid xs={12}>
                                        <img style={{width: 96, height: 96}} alt="avatar2" src={AvatarIcon}/>
                                        {
                                            this.state.userData !== null ? <Typography style={{
                                                fontWeight: 'bold',
                                                fontSize: 18,
                                                marginBottom: 18,
                                                marginRight: 16,
                                                color: 'green',
                                            }}>{this.state.userData.name}</Typography> : ""
                                        }


                                    </Grid>) : (
                                    <React.Fragment style={{width: '100%'}} alignItems='center' justifyContent='center'
                                                    align='center'>


                                        <Grid xs={12}>
                                            <img style={{
                                                borderRadius: '50%',
                                                margin: '8px'
                                                , width: 96, height: 96
                                            }}
                                                 alt="avatar2"
                                                 src={this.state.userData.picture != null ? AVATAR_BASE_URL_API + this.state.userData.picture.url : AvatarIcon}/>

                                        </Grid>

                                        <Grid xs={12}>

                                            <Typography style={{
                                                marginLeft: 16,
                                                fontWeight: 'bold',
                                                fontSize: 18,
                                                paddingRight: 16,
                                                color: 'gray',

                                            }}
                                                        align='center'>
                                                {"شماره تلفن: " + this.state.userData.phone}
                                            </Typography>
                                        </Grid>

                                        <Grid style={{
                                            marginBottom: 64,
                                        }} xs={12} container alignItems='center' justifyContent='center' align='center'>
                                            <img alt="wallet" style={{width:18,height:18}} src={WalletIcon} align='center'/>

                                            <Typography style={{
                                                marginLeft: 16,
                                                fontWeight: 'bold',
                                                fontSize: 16,
                                                paddingRight: 16,
                                                color: 'green',

                                            }}
                                                        align='center'>
                                                {"موجودی: " + this.state.userData.wallet}
                                            </Typography>
                                        </Grid>

                                        <Grid xs={1}>
                                            <AddCardIcon/>
                                        </Grid>
                                        <Grid xs={11}>
                                            <TextField
                                                onChange={handleOnchangeName}
                                                defaultValue={this.state.userData.name}
                                                placeholder={'نام و نام خانوادگی'}
                                                style={{
                                                    marginLeft: 16,
                                                    width: '70%',
                                                    fontWeight: 'bold',
                                                    fontSize: 18,
                                                    color: 'black',
                                                }}/> </Grid>

                                        <Grid xs={1} style={{marginTop: 18}}>
                                            <EditLocationAltIcon/>
                                        </Grid>
                                        <Grid xs={11} style={{marginTop: 18}}>
                                            <TextField
                                                onChange={handleOnchangeAddress}

                                                defaultValue={this.state.userData.address}
                                                placeholder={'آدرس'}
                                                style={{
                                                    marginLeft: 16,
                                                    width: '70%',
                                                    fontWeight: 'bold',
                                                    fontSize: 18,
                                                    color: 'black',
                                                }}/> </Grid>

                                        <Grid xs={1} style={{marginTop: 18}}>
                                            <WysiwygIcon/>
                                        </Grid>

                                        <Grid xs={11} style={{marginTop: 18}}>
                                            <TextField
                                                onChange={handleOnchangePostalcode}

                                                defaultValue={this.state.userData.postalcode}
                                                placeholder={'کد پستی'}
                                                style={{
                                                    marginLeft: 16,
                                                    width: '70%',
                                                    fontWeight: 'bold',
                                                    fontSize: 18,
                                                    color: 'black',
                                                }}/> </Grid>


                                        <Grid item xs={8} style={{marginTop: 150, marginBottom: 100}}>

                                            <Button onClick={() => onUpdateProfileClicked()} variant="contained" style={{
                                                width: '40%',
                                                color: 'white',
                                                background: "#FF1744"
                                            }}
                                                    align='right'>{"ویرایش"}</Button>
                                        </Grid>

                                    </React.Fragment>

                                )
                        }
                    </Grid>

                    <Snackbar open={this.state.openSnackbar} autoHideDuration={6000} onClose={handleCloseSnackbar}>
                        <Alert onClose={handleCloseSnackbar} severity={this.state.snackbarType} sx={{width: '100%'}}>
                            {this.state.message}
                        </Alert>
                    </Snackbar>
                </div>
                <BottomMenu/>
            </React.Fragment>
        );
    }


}
